import React from 'react';
import { Stack, HStack, VStack, Box, Text } from '@chakra-ui/react';
import Navbar from '../components/navbar';
import { Link } from 'react-router-dom';
const Statigy = () => {
  return (
    <>
      <Box bg={'#91B8B4'} h={'145vh'}>
        <Navbar />
        <VStack spacing={4} align="stretch" alignItems={'center'}>
          <Box>
            <HStack spacing="24px" mt={'50px'} mb={'10px'}>
              <Text fontSize="60px" color={'#0F2837'}>
                إستراتيجية ترجم
              </Text>
            </HStack>
          </Box>
          <Box mt={'30px !important'}>
            <Box
              border={'1px solid '}
              h={'160px'}
              mb={'30px'}
              textAlign={'center'}
              w="800px"
              bg={'#0F2837'}
   
              borderRadius={'10px '}
            >
              <Text mt={'20px'} p={'5px'} fontSize="30px" color={'#fff'}>
                تجسير الهوية المعرفية بين العالم العربي والعالم عن طريق الترجمة
                المنتقاة كماًّ وكيفاً بما يثري ثقافة المجتمع ويحقق لأفراده
                متطلبات التطور والنمو والتعلم
              </Text>
            </Box>
            <Box
              border={'1px solid '}
              h={'160px'}
              mb={'30px'}
              textAlign={'center'}
              w="800px"
              bg={'#0F2837'}
              fontSize={'50px'}
              borderRadius={'10px '}
            >
              <Text mt={'20px'} p={'5px'}  fontSize="30px" color={'#fff'}>
                إتاحة محتوى معرفي متجدد عن طريق الترجمة يعمل كمحرك للنمو
                الاقتصادي وممكّن لاقتصاد المعرفة وموطن للتقنيات الحديثة ومعزز
                للتبادل التجاري
              </Text>
            </Box>
            <Box
              border={'1px solid '}
              h={'160px'}
              mb={'30px'}
              textAlign={'center'}
              w="800px"
              bg={'#0F2837'}
             
              borderRadius={'10px '}
            >
              <Text mt={'20px'} p={'5px'}  fontSize="30px" color={'#fff'}>
                ترسيخ مكانة المملكة في العالم العربي كقائد لجهود خدمة الثقافة
                العربية وفي العالم أجمع كبوابة للتبادل المعرفي والثقافي والحضاري
                بينه وبين العالم العربي
              </Text>
            </Box>
          </Box>
        </VStack>
        <Box>
          <HStack
            spacing="50px"
            justifyContent={'left'}
            mt={'190px'}
            mb={'50px'}
            ml={'50px'}
          >
            <Link to="/">
              <Box
                textAlign={'center'}
                w="190px"
                h="50px"
                color={'#fff'}
                bg={'#0F2837'}
                fontSize={'30px'}
                borderRadius={'10px'}
              >
                الرجوع للخلف
              </Box>
            </Link>
          </HStack>
        </Box>
      </Box>
    </>
  );
};

export default Statigy;
